<template>
  <div>
    <label for="bookingStoreSelected"
      >Store<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="bookingStoreSelected"
      v-model="store"
      :options="stores"
      label="text"
      track-by="id"
      :disabled="setDisable"
      style="margin: 0.6rem 0 0"
    >
    </multiselect>
  </div>
</template>

<script>
import BookingService from "services/api/booking.service";
import { assembleDropdown } from "@/utils/dropdown";
import { emitLoadingStart, emitLoadingDone } from "@/utils/loading";

export default {
  name: "BookingStoreDropdown",
  props: {
    value: { type: Object, default: null },
    setDisable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    brandCode: { type: String, default: null },
  },
  data() {
    return {
      store: this.value,
      stores: [],
    };
  },
  created() {
    if (this.brandCode) {
      this.getStores(this.brandCode);
    } else {
      this.stores = [];
    }
  },
  watch: {
    store(newValue) {
      this.$emit("setStore", newValue);
    },
    value(newValue) {
      this.store = newValue;
    },
    stores(newValue) {
      this.$emit("setStores", newValue);
    },
    brandCode(newBrandCode) {
      if (newBrandCode) {
        this.getStores(newBrandCode);
      } else {
        this.stores = [];
      }
    },
  },
  methods: {
    async getStores(brandCode) {
      try {
        emitLoadingStart(this);
        await BookingService.getStores({ brandCode: brandCode })
          .then(async (res) => {
            this.stores = assembleDropdown(await res.data.items);
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
      emitLoadingDone(this);
    },
  },
};
</script>
